

import React, { useEffect, useState } from 'react';

import { DashboardLayout, GeneralTable } from "components";

import { func_validation, getObjectPropertyValue_caseInsensitive, getTotalCountFromHeader, isArrayNotEmpty, isNumberOrStringValid, isObjectEmpty } from 'functions';
import { columns } from './advancePayColumns';

import 'assets/scss/billingPortal/modules/advancePay/advancePaySetup.scss';
import { 
    useAlertMessage, useInvoiceGeneration, 
    useDebitNoteGeneration, useAccountDeletion,
    useDropdownList
} from './hooks';

import ic_add_account from "assets/images/ic_add_account.svg";
import { Button, Dropdown } from "components";
import { SubmenuTooltip } from 'components/informational/SubmenuTooltip';
import { MoreButton } from 'components/buttons/MoreButton';
import AccountUpdate from './accountUpdate/AccountUpdate';
import { Toaster } from 'components/notification/Toaster';
import { useTabs } from './hooks/useTabs';
import { MultiFilters } from 'components/filters/MultiFilters';
import { useUpdateStatus } from './hooks/useUpdateStatus';
import { current } from 'immer';



export default function AdvancePaySetupPresentation(props) {
    const { 
        getAdvancePaySetupList_requesting, getAdvancePaySetupList_status,
        advancePaySetupList, advancePaySetupListHeaders,

        history,

        addAccount_errorMsg, updateAccount_errorMsg,

        generateInvoice_requesting,
        generateDebitNote_requesting,

        isAccountRecordUpdatedSuccessfully,
        totalRequests,

        allAdvancePaySetupList
    } = props;

    const [selectedAccount, setSelectedAccount] = useState([]);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isEditingAccount, setIsEditingAccount] = useState();
    const [isCloning, setIsCloning] = useState();
    const [isFilterReset, setIsFilterReset] = useState();
    const [isModalVisible_updateStatus, setIsModalVisible_updateStatus] = useState();


    useEffect(() => {
        if (!isFormVisible) setIsCloning(false);
    }, [isFormVisible]);

    const {
        alertMsgDisplay,
        setAlertMsg
    } = useAlertMessage({
        ...props
    });

    const {
        setIsModalVisible: setIsModalVisible_generateInvoice,
        generateInvoiceModal
    } = useInvoiceGeneration({
        ...props,
        setAlertMsg,
        selectedAccount
    });

    const {
        generateDebitNoteModal,
        setIsModalVisible: setIsModalVisible_generateDebitNote
    } = useDebitNoteGeneration({
        ...props,
        setAlertMsg,
        selectedAccount
    });

    const {
        setIsModalVisible_deleteAccount,
        deleteModal
    } = useAccountDeletion({
        ...props,
        setAlertMsg,
        selectedAccount
    });

    // Tabs
    const {
        currentTabId, setCurrentTabId,
        tabsDetails, submenuActions
    } = useTabs({
        ...props,
        setIsCloning,
        selectedAccount, setSelectedAccount,
        setIsFormVisible, setIsEditingAccount,
        setIsModalVisible_generateInvoice,
        setIsModalVisible_deleteAccount,
        setIsModalVisible_updateStatus
    });
    useEffect(() => {
        setIsFilterReset(true);
    }, [currentTabId]);
    useEffect(() => {
        if (isFilterReset) setIsFilterReset(false);
    }, [isFilterReset]);
    
    // Dropdown Lists
    const {
        comIdList,
        accountCodeList,
        productCodeList,
        dealerCodeList,
        salesPersonCodeList,
        productNameList,

        filter, setIsRenderRequired, isRenderRequired
    } = useDropdownList({
        ...props,
    });

    const {
        updateStatusModal
    } = useUpdateStatus({
        ...props,
        currentTabId,
        selectedAccount,
        isModalVisible_updateStatus, setIsModalVisible_updateStatus
    })

    useEffect(() => {
        if (!isFormVisible) setSelectedAccount([]);
        setCurrentTabId("pending");
    }, [isFormVisible]);

    return (
        <div className={"advance-pay-setup"}>
            {/* Delete Modal */}
            {deleteModal}

            {/* Update Status Modal */}
            {updateStatusModal}

            {/* Generate Invoice */}
            {generateInvoiceModal}

            {/* Generate Debit Note */}
            {generateDebitNoteModal}

            {(!isFormVisible)? (
                <DashboardLayout
                    headerTitle={"Commitment Pay Setup"}

                    bodyClassName={"advance-pay-setup__body"}
                    body={(
                        <GeneralTable
                            className={"body__table"}
                            columns={columns.getColumns()}
                            data={advancePaySetupList}
                            minRows={10}

                            getTableData={props.getAdvancePaySetupList}
                            isTableRefreshRequired={isAccountRecordUpdatedSuccessfully}

                            onFilterUpdate={(value) => { filter.current = value; setIsRenderRequired(!isRenderRequired); }}

                            topOuterTableHeader={() => {
                                if (!alertMsgDisplay) return "";
                                
                                return (
                                    <div className={"pb-3"}>
                                        {alertMsgDisplay}
                                    </div>
                                );
                            }}
                            outerTableHeader={(outerTableHeader_props) => {
                                const { 
                                    selectedRows: selectedAccounts,
                                    filterOptions, setFilterOptions
                                } = outerTableHeader_props;
                                
                                return (
                                    <>
                                        <div className={"table__header d-flex align-items-center justify-content-between "}>
                                            <div className={"header__title tableHeaderTitle "}>
                                                Account List
                                            </div>

                                            <div className={"header__action d-flex align-items-center"}>
                                                
                                                <div className={"action__wrapper"}>
                                                    <Button
                                                        className={"action-wrapper__main-action tableHeaderButtonPadding d-flex align-items-center"}
                                                        handleOnClick={() => { 
                                                            setIsFormVisible(true);
                                                            setIsEditingAccount(false);
                                                        }}

                                                        // isDisabled={func_validation.isUserAccessDenied(props, "Internal_ProformaInvoice_Send")}
                                                        isDecoration_primaryTransparent
                                                    >
                                                        <img
                                                            className={"main-action__icon"}
                                                            src={ic_add_account}
                                                            alt={"Mail Icon"}
                                                        />

                                                        <span className={"main-action__text tableHeaderButtonText "}>Add Account</span>
                                                    </Button>
                                                </div>

                                                <SubmenuTooltip
                                                    buttonClassName={"action__more-action-wrapper"}
                                                    menuItems={submenuActions(selectedAccounts)}
                                                >
                                                    <MoreButton
                                                        className={"more-action-wrappe__more-action"}
                                                        iconClassName={"more-action__icon"}
                                                    />
                                                </SubmenuTooltip>
                                            </div>
                                        </div>

                                        {/* Table Filters */}
                                        <div className={"table__table-filter d-flex flex-wrap align-items-center"}>
                                            <MultiFilters
                                                defaultFilterOption={{
                                                    label: "Company ID", 
                                                    propertyName: "comId",
                                                    placeholder: "Company ID",
                                                    suggestionList: [{ label: "All", value: "All" }].concat(comIdList),
                                                    inputType: "search",
                                                    isInputDigitOnly: true
                                                }}
                                                filterOptions={[
                                                    {
                                                        label: "Company ID", 
                                                        propertyName: "comId",
                                                        placeholder: "Company ID",
                                                        suggestionList: [{ label: "All", value: "All" }].concat(comIdList),
                                                        inputType: "search",
                                                        isInputDigitOnly: true
                                                    },
                                                    {
                                                        label: "Account Code", 
                                                        propertyName: "accountCode",
                                                        placeholder: "Account Code",
                                                        suggestionList: [{ label: "All", value: "All" }].concat(accountCodeList),
                                                        inputType: "search"
                                                    },
                                                    {
                                                        label: "Product Code", 
                                                        propertyName: "productCode",
                                                        placeholder: "Product Code",
                                                        suggestionList: [{ label: "All", value: "All" }].concat(productCodeList),
                                                        inputType: "search"
                                                    }
                                                ]}
                                                dropdownPlaceholder={"Select Filter"}
                                                onApplyFilter={(inputFilters) => {
                                                    // find matched tab
                                                    let defaultFilter = {}
                                                    tabsDetails.map((tabObj, idx) => {
                                                        if (tabObj?.id === currentTabId) {
                                                            defaultFilter = tabObj?.filters? tabObj?.filters: { status: 1 };
                                                        }
                                                    })
                                                    setFilterOptions(isObjectEmpty(inputFilters)? defaultFilter: { ...filterOptions, ...inputFilters});
                                                }}
                                                isResetFromParentRequired={isFilterReset}
                                            />
                                        </div>
                                    </>
                                );
                            }}

                            tabsDetails={tabsDetails}
                            onTabIdChange={(tabId) => {
                                setIsFilterReset(true);
                                setCurrentTabId(tabId);
                            }}
                            defaultTabId={currentTabId}
                            defaultFilter={{
                                status: 1
                            }}
                            isTabRequired
                            
                            isTableDataLoading={getAdvancePaySetupList_requesting}

                            isUsingPagination
                            totalRecords={getTotalCountFromHeader(advancePaySetupListHeaders)}

                            isColumnResizeable
                            isTableOddRowsDarken
                            isCheckboxRequired isCheckboxColumnFirst
                            onCheckboxDisabledValidationList={(row, selectedIndexes, data) => {
                                // Get current row's accoutn code
                                let current_comId = row?.original?.CompanyId;
                                let current_accountCode = row?.original?.AccountCode;
                                let current_nextBilledDate = row?.original?.NextBillDateTime;

                                if (isArrayNotEmpty(data)) {
                                    let disabledList = data.map((details, idx) => {
                                        if (!selectedIndexes[idx]) {
                                            // Find any matched account code
                                            for (let index in selectedIndexes) {
                                                if (selectedIndexes.hasOwnProperty(index) &&
                                                    isNumberOrStringValid(index)) {
                                                    
                                                    let index_formatted = parseInt(index);
                                                    let selectedComId = data[index_formatted].CompanyId;
                                                    let selectedAccountCode = data[index_formatted].AccountCode;
                                                    let selectedNextBilleDate = data[index_formatted].NextBillDateTime;

                                                    if (selectedComId === current_comId &&
                                                        selectedAccountCode === current_accountCode &&
                                                        selectedNextBilleDate === current_nextBilledDate) {
                                                        return true;
                                                    }
                                                }
                                            }
                                            
                                        }

                                        return false;
                                    });

                                    return disabledList;
                                }

                                return [];
                            }}
                        />
                    )}
                />
            ):(
                <AccountUpdate 
                    {...props}
                    isEditing={isEditingAccount}
                    isCloning={isCloning}
                    isFormVisible={isFormVisible}
                    history={history}

                    allAdvancePaySetupList={allAdvancePaySetupList}
                    advancePaySetup={selectedAccount[0]}

                    comIdList={comIdList}
                    accountCodeList={accountCodeList}
                    dealerCodeList={dealerCodeList}
                    salesPersonCodeList={salesPersonCodeList}

                    productCodeList={productCodeList}
                    productNameList={productNameList}

                    updateParentState_visiblity={setIsFormVisible}

                    addAccount={props.addAccount}
                    updateAccount={props.updateAccount}

                    isAccountRecordUpdatedSuccessfully={isAccountRecordUpdatedSuccessfully}
                    isAccountRecordUpdateRequesting={props.isAccountRecordUpdateRequesting}

                    addAccount_errorMsg={addAccount_errorMsg}
                    updateAccount_errorMsg={updateAccount_errorMsg}
                />
            )}
           
        </div>
    );
}